import {
    BULK_TAGS_REQUEST,
    BULK_TAGS_RESULT,
    BULK_TAGS_OPEN_MODAL,
    BULK_TAGS_CLOSE_MODAL,
    BULK_TAGS_GET_DEVICE_REQUEST,
    BULK_TAGS_GET_DEVICE_RESULT,
    BULK_TAGS_SET_DEVICE,
} from 'Redux/actionTypes';

export const bulkTagsRequest = (data) => ({
    type: BULK_TAGS_REQUEST,
    payload: data
})

export const bulkTagsResult = (result) => ({
    type: BULK_TAGS_RESULT,
    payload: result
})

export const bulkTagsOpenModal = (items) => ({
    type: BULK_TAGS_OPEN_MODAL,
    payload: items
})

export const bulkTagsCloseModal = () => ({
    type: BULK_TAGS_CLOSE_MODAL
})

export const bulkTagsGetDeviceRequest = (item) => ({
    type: BULK_TAGS_GET_DEVICE_REQUEST,
    payload: item
})

export const bulkTagsGetDeviceResult = (result) => ({
    type: BULK_TAGS_GET_DEVICE_RESULT,
    payload: result
})

export const bulkTagsSetDevice = (device) => ({
    type: BULK_TAGS_SET_DEVICE,
    payload: device
})